export const appStatusBetaTag = "Zgytde";
export const appStatusPreviewTag = "zs7zId";
export default {appStatusBetaTag,appStatusPreviewTag};